import { render, staticRenderFns } from "./zt-set-driver-adas-alarm-modal.vue?vue&type=template&id=471d8915&"
import script from "./zt-set-driver-adas-alarm-modal.vue?vue&type=script&lang=js&"
export * from "./zt-set-driver-adas-alarm-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports